"use client";
import React, { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { useAppSelector } from "@/redux/store";
import Search from "../Search/Search";

export default function MenuBarMobile({ setter }: any) {

  const authValue = useAppSelector((state) => state.appReducer.auth);
  const userData = useAppSelector((state) => state.appReducer.userData);
  const [isSearchOpen, setIsSearchOpen] = useState(false);




  return (
    <>
      {isSearchOpen && <Search setIsSearchOpen={setIsSearchOpen} />}
      {authValue.isAuth && userData?.tags && (
        <nav
          className={`md:hidden z-20 fixed top-0 left-0 right-0 h-[60px] flex justify-between items-center px-2 bg-white/70 backdrop-blur-lg`}
        >
          <div className="flex">
            <button
              className="text-4xl flex text-white"
              onClick={() => {
                setter((oldVal: any) => !oldVal);
              }}
            >
              <Image
                height={28}
                width={28}
                className="mt-0"
                src="/images/Mobile_Menu.svg"
                alt="c-tribe"
              />
            </button>

            <Link href="/" className="ml-4">
              <Image
                height={25}
                width={58}
                className="mt-0"
                src="/images/C-Tribe_Main_Logo.svg"
                alt="c-tribe"
              />
            </Link>
          </div>

          <div className="flex flex-row justify-start items-center">
            <button
              data-modal-target="default-modal"
              data-modal-toggle="default-modal"
              className="py-4 px-0 relative border-2 border-transparent text-gray-800 rounded-full hover:text-gray-400 focus:outline-none focus:text-gray-500 transition duration-150 ease-in-out"
              aria-label="Notification"
            >
              <Image
                height={20}
                width={20}
                className="mt-0"
                src="/images/notification_icon.svg"
                alt="c-tribe"
              />
            </button>
            <div>
              <Image
                height={20}
                width={20}
                className="ml-4 mr-6"
                src="/images/search_icon.svg"
                alt="c-tribe"
                onClick={() => setIsSearchOpen(true)}
              />
            </div>
          </div>
        </nav>
      )}
    </>
  );
}
